import { gql } from "graphql-request";

const CreateCompanyQuery = gql`
  mutation CreateCompany($input: CreateCompanyInput!) {
    CreateCompany(input: $input)
  }
`;
export default CreateCompanyQuery;
